import styled from '@emotion/styled';

import { inputFocusStyles } from './utils/mixins';
import { COLOR_BORDER_INPUT, COLOR_TEXT_PRIMARY, RADIUS_MD } from './utils/variables';

export const FieldTextArea = styled.textarea`
  border: 1px solid ${COLOR_BORDER_INPUT};
  border-radius: ${RADIUS_MD};
  padding: 10px 12px;
  font-size: 14px;
  line-height: 1.5;
  color: ${COLOR_TEXT_PRIMARY};
  min-height: 120px;
  resize: vertical;
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;

  &:focus {
    ${inputFocusStyles}
  }
`;
